import {
  OpportunityReviewBoardParam,
  OpportunityReviewBoardReq,
  OpportunityReviewTableResponse,
  TableParam,
} from '@models/OpportunityReview';
import axios from 'axios';
import { environment } from '@environments/environment';
import { getPeriodMetaFactory } from '@utils/PeriodUtils';
import { ProductDataType } from '@pages/product-analyzer/Product';
import { getQueryClient } from '@queries/QueryClientWrapper';
import { applyCommonFilterParamsToRequest } from '@utils/serviceUtils/RequestFormatter';

export const getOpportunityReviewTable = async (param: TableParam): Promise<any> => {
  const qc = getQueryClient('opportunity-review');
  const {
    clientId,
    productType,
    countryIds,
    productGroup,
    period,
    comparisonPeriod,
    periodType,
    sortOption,
    growthType,
    appliedFilters,
    segment,
    dataType,
    pageRequest,
    oRGroups,
  } = param;
  const sortKey = sortOption.label?.toUpperCase();
  const opportunityReviewBoardParam: OpportunityReviewBoardParam = {
    clientId,
    productType,
    productDataType: ProductDataType.PerformanceAnalyzer,
    countryIds,
    productGroupForOpportunityReview: productGroup,
    period,
    //Future implementation of Custom Month, need to cater for BaseTimePeriod
    comparisonPeriod,
    periodType,
    appliedFilters,
    segment,
    dataType,
    oRGroups,
  };
  const requestPayload = constructRequest(opportunityReviewBoardParam);
  const queryKey = [
    'opportunity-review-table',
    {
      ...param,
      sortKey,
      growthType: growthType.toUpperCase(),
      opportunityReviewBoardParam: requestPayload,
    },
  ] as const;

  const url = `${environment.baseUrl}/v2/opportunity-review/swot-table?page=${pageRequest.page}&size=${pageRequest.size}&sortBy=${sortOption.headerKey}&sortDirection=${sortOption.sortDir}&sortKey=${sortKey}&growthType=${growthType.toUpperCase()}`;

  return await qc.fetchQuery<OpportunityReviewTableResponse | null>({
    queryKey,
    queryFn: async ({ signal }) => {
      try {
        const response = await axios.post<OpportunityReviewTableResponse>(url, requestPayload, { signal });
        const data = response?.data;
        if (!data.salesRecordsFound) {
          return null;
        }
        return data;
      } catch (err) {
        console.error(`An error has occurred: ${err}`);
        return null;
      }
    },
  });
};

const constructRequest = ({
  clientId,
  productType,
  countryIds,
  productGroupForOpportunityReview,
  period,
  comparisonPeriod,
  periodType,
  appliedFilters,
  segment,
  dataType,
  oRGroups,
}: OpportunityReviewBoardParam): OpportunityReviewBoardReq => {
  const req = {} as OpportunityReviewBoardReq;
  const periodMetaForSwot = getPeriodMetaFactory(period, comparisonPeriod, periodType, undefined, true);

  req.clientId = clientId;
  req.productType = productType;
  req.productDataType = ProductDataType.PerformanceAnalyzer;
  req.country = countryIds;

  if (productGroupForOpportunityReview && productGroupForOpportunityReview.length !== 0) {
    req.productGroup = productGroupForOpportunityReview.map((option) => {
      return option.value;
    });
  }

  req.periodType = periodType ? periodType.replace(/ /g, '').toUpperCase() : '';
  req.period = periodMetaForSwot ? periodMetaForSwot.currentPeriod.toUpperCase() : '';
  req.comparisonPeriod = periodMetaForSwot ? periodMetaForSwot.comparisonPeriod.toUpperCase() : '';
  //Temporary
  req.showPerformance = segment;
  req.dataType = dataType;
  req.oRGroups = oRGroups.filter((group) => group.showPerformanceWithin === segment);

  appliedFilters.forEach((filter) => {
    if (filter.filterKey >= 2) {
      applyCommonFilterParamsToRequest(req, filter);
    }
  });
  return req;
};
